import { create } from "zustand";
import { persist } from "zustand/middleware";
import { TTaskData } from "../types/task";

interface TaskStore {
	task: TTaskData | null;
	setTask: (task: TTaskData) => void;
}

export const useTaskStore = create<TaskStore>()(
	persist(
		(set) => ({
			task: null,
			setTask: (task: TTaskData) => set({ task }),
		}),
		{
			name: "task-store",
		}
	)
);
